// extracted by mini-css-extract-plugin
export default {"icon":"ControlledIconPicker_icon__axuV5","iconGroup":"ControlledIconPicker_iconGroup__K8KyE","changeIconButton":"ControlledIconPicker_changeIconButton__BLx+q"};